exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1lxsc{background-color:#e4002b;cursor:pointer;width:140px}.yC0p7{font-family:Roboto\\, Medium}._3qxDX{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;width:140px}._1veou{position:relative}._1veou i{position:absolute;padding:10px;pointer-events:none}._2jLs4 i{left:0}._2jLs4 input{padding-left:35px}input:focus{border-color:#e4002b!important}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_1lxsc",
	"robotoMedium": "yC0p7",
	"boton_blanco": "_3qxDX",
	"innerAddon": "_1veou",
	"leftAddon": "_2jLs4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalConfirmacionTurno/ModalConfirmacionTurno.css
// module id = 1222
// module chunks = 0 1 2